"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[38255],{

/***/ 21550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Alert(param) {
    var children = param.children, className = param.className, type = param.type, open = param.open, setOpen = param.setOpen;
    var typeIcon = function(type) {
        switch(type){
            case "warning":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-4 h-4 flex-shrink-0 fill-current opacity-80 mt-[3px] mr-3",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z"
                    })
                });
            case "error":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-4 h-4 flex-shrink-0 fill-current opacity-80 mt-[3px] mr-3",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.5 10.1l-1.4 1.4L8 9.4l-2.1 2.1-1.4-1.4L6.6 8 4.5 5.9l1.4-1.4L8 6.6l2.1-2.1 1.4 1.4L9.4 8l2.1 2.1z"
                    })
                });
            case "success":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-4 h-4 flex-shrink-0 fill-current opacity-80 mt-[3px] mr-3",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z"
                    })
                });
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-4 h-4 flex-shrink-0 fill-current opacity-80 mt-[3px] mr-3",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
                    })
                });
        }
    };
    var typeColor = function(type) {
        switch(type){
            case "warning":
                return "bg-yellow-100 border-yellow-200 text-yellow-600";
            case "error":
                return "bg-red-100 border-red-200 text-red-600";
            case "success":
                return "bg-green-100 border-green-200 text-green-600";
            default:
                return "bg-indigo-100 border-indigo-200 text-indigo-500";
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (open) {
            var timer = setTimeout(function() {
                setOpen(false);
            }, 2500);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: className,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-4 py-2 rounded-sm text-sm border ".concat(typeColor(type)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex w-full justify-between items-start",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex",
                            children: [
                                typeIcon(type),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: children
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            className: "opacity-70 hover:opacity-80 ml-3 mt-[3px]",
                            onClick: function() {
                                return setOpen(false);
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "sr-only",
                                    children: "Close"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    className: "w-4 h-4 fill-current",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Alert);


/***/ }),

/***/ 5077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var CustomLoading = function(param) {
    var decrease_width = param.decrease_width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: [
            " fixed h-screen top-0 right-0 bg-gray-500   bg-opacity-25",
            , 
        ].join(" "),
        style: {
            zIndex: "999999999999999999999999999999999999999999999999999",
            width: decrease_width ? "calc(100VW - ".concat(decrease_width, "px)") : "100vW"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: " w-full h-full flex justify-center items-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-primary "
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomLoading);


/***/ }),

/***/ 46316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var ErrorComponent = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute left-1/2 transform -translate-x-1/2 -mb-64 bottom-0 pointer-events-none z-[-1]",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    width: "1360",
                    height: "578",
                    viewBox: "0 0 1360 578",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                                x1: "50%",
                                y1: "0%",
                                x2: "50%",
                                y2: "100%",
                                id: "illustration-01",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        stopColor: "#FFF",
                                        offset: "0%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        stopColor: "#EAEAEA",
                                        offset: "77.402%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                        stopColor: "#DFDFDF",
                                        offset: "100%"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                            fill: "url(#illustration-01)",
                            fillRule: "evenodd",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                    cx: "1232",
                                    cy: "128",
                                    r: "128"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                    cx: "155",
                                    cy: "443",
                                    r: "64"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "max-w-6xl mx-auto px-4 sm:px-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "pt-16 pb-12 md:pt-20 md:pb-20",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-3xl mx-auto text-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "h1 mb-4",
                                children: "Oh, No! You stumbled upon a rarity"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-8",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "btn text-white bg-blue-600 hover:bg-blue-700",
                                        children: "Go back home"
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorComponent);


/***/ }),

/***/ 86707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Button_loading = function(param) {
    var text_color = param.text_color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: "animate-spin -ml-1 mr-3 h-5 w-5 ".concat(text_color),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button_loading);


/***/ }),

/***/ 38255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Signup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/uuidv4/build/lib/uuidv4.js
var uuidv4 = __webpack_require__(26281);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/Shared/Alert/Alert.jsx
var Alert = __webpack_require__(21550);
// EXTERNAL MODULE: ./src/Shared/Loader/Button_loading.jsx
var Button_loading = __webpack_require__(86707);
// EXTERNAL MODULE: ./constant/url.js
var url = __webpack_require__(99741);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
// EXTERNAL MODULE: ./constant/functions.js
var functions = __webpack_require__(60538);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);

// EXTERNAL MODULE: ./constant/mixpnael.js
var mixpnael = __webpack_require__(70441);
// EXTERNAL MODULE: ./node_modules/mixpanel-browser/dist/mixpanel.module.js
var mixpanel_module = __webpack_require__(83198);
// EXTERNAL MODULE: ./src/utils/discourse_auth.js
var discourse_auth = __webpack_require__(65233);
// EXTERNAL MODULE: ./src/utils/tradly_integration_auth.js
var tradly_integration_auth = __webpack_require__(20435);
// EXTERNAL MODULE: ./src/Shared/CustomLoading.jsx
var CustomLoading = __webpack_require__(5077);
// EXTERNAL MODULE: ./constant/AllIcons.js
var AllIcons = __webpack_require__(47520);
;// CONCATENATED MODULE: ./data/WhatYouWantTobuild.js
var build_examples = [
    {
        type: "Marketplace Platform",
        description: "I want to build a platform where users can buy and sell various products or services easily."
    },
    {
        type: "Community Platform",
        description: "A social platform focused on connecting people with similar interests and encouraging community engagement."
    },
    {
        type: "Subscription-Based Platform",
        description: "A service offering exclusive content or products through a subscription model."
    },
    {
        type: "Event Management Platform",
        description: "A platform for organizing, promoting, and managing events, allowing users to book tickets or register."
    },
    {
        type: "Booking Platform",
        description: "An application where users can book appointments, make reservations, or rent assets."
    },
    {
        type: "Digital Content Store",
        description: "A store for selling downloadable digital products like e-books, courses, music, or software."
    },
    {
        type: "Ad Network Platform",
        description: "A solution to connect advertisers with publishers, especially within specific niche markets or industries."
    },
    {
        type: "B2B Trading Platform",
        description: "A platform facilitating business-to-business transactions for wholesale or bulk purchasing."
    },
    {
        type: "Donation or Fundraising Platform",
        description: "A platform dedicated to raising funds for charities, personal causes, or social initiatives."
    },
    {
        type: "Learning or Educational Platform",
        description: "A platform for providing online educational courses, workshops, or tutoring services."
    },
    {
        type: "Job Board Platform",
        description: "A platform for posting job vacancies, allowing companies to connect with potential employees."
    },
    {
        type: "Service Marketplace Platform",
        description: "A marketplace for finding and hiring freelancers or service providers in various industries."
    }, 
];

;// CONCATENATED MODULE: ./src/components/Auth/Signup.jsx


























var Sign_up = function(param) {
    var sso = param.sso, sig = param.sig, is_log_in_by_discourse = param.is_log_in_by_discourse, is_log_in_by_tradly_integration = param.is_log_in_by_tradly_integration, isLoggedIn = param.isLoggedIn;
    var ref;
    var router = (0,next_router.useRouter)();
    var redirect_url = router.query.to || url.default_site_url;
    var recaptchaRef = (0,react.useRef)(null);
    // Alert
    var ref1 = (0,react.useState)(false), open_alert = ref1[0], setOpenAlert = ref1[1];
    var ref2 = (0,react.useState)(""), message = ref2[0], setMessage = ref2[1];
    var ref3 = (0,react.useState)("success"), alert_type = ref3[0], setAlert_type = ref3[1];
    var ref4 = (0,react.useState)(false), isValidUser = ref4[0], setIsValidUser = ref4[1];
    var ref5 = (0,react.useState)(null), captchaToken = ref5[0], setCaptchaToken = ref5[1];
    //
    var ref6 = (0,react.useState)(false), isLoading = ref6[0], setIsLoading = ref6[1];
    var ref7 = (0,react.useState)(null), countries = ref7[0], setCountries = ref7[1];
    // react hook form
    var ref8 = (0,index_esm/* useForm */.cI)(), register = ref8.register, handleSubmit = ref8.handleSubmit, setValue = ref8.setValue, errors = ref8.formState.errors;
    //
    (0,react.useEffect)(function() {
        setValue("uuid", (0,uuidv4/* uuid */.Vj)());
        setValue("type", "tenant");
        // plan select and set and value
        if (localStorage.getItem("selected_plan")) {
            setValue("metadata.plan", localStorage.getItem("selected_plan"));
        } else {
            setValue("metadata.plan", "community_monthly");
        }
        // channel set
        if (is_log_in_by_discourse) {
            setValue("metadata.channel", "discourse");
        } else {
            setValue("metadata.channel", "direct");
        }
        // country api calling
        axios_default().get("/api/countries").then(function(res) {
            var ref;
            setCountries((ref = res.data.countries_res) === null || ref === void 0 ? void 0 : ref.countries);
            if (res.data.IP_COUNTRY) {
                var ref1;
                setValue("metadata.country_id", (ref1 = res.data.countries_res) === null || ref1 === void 0 ? void 0 : ref1.countries.find(function(cn) {
                    return cn.code2 == res.data.IP_COUNTRY;
                }).id);
            } else {
                var ref2;
                setValue("metadata.country_id", (ref2 = res.data.countries_res) === null || ref2 === void 0 ? void 0 : ref2.countries[0].id);
            }
        }).catch(function(err) {
            var ref, ref1;
            var message = err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message;
            setIsLoading(false);
            if (message) {
                setOpenAlert(true);
                setAlert_type("error");
                setMessage(message);
            } else {
                if (message) {
                    setOpenAlert(true);
                    setAlert_type("error");
                    setMessage("Something is wrong , please try latter");
                }
            }
        });
    }, [
        router
    ]);
    // Submit login form
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var ref, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                // pass check
                if ((data === null || data === void 0 ? void 0 : (ref = data.password) === null || ref === void 0 ? void 0 : ref.length) < 8) {
                    setOpenAlert(true);
                    setAlert_type("error");
                    setMessage("Minimum password size is 8 letters.");
                    return [
                        2,
                        false
                    ];
                }
                // console.log(data);
                if (captchaToken == null) {
                    setOpenAlert(true);
                    setAlert_type("error");
                    setMessage("Please complete captcha verification to register.");
                    return [
                        2,
                        false
                    ];
                } else {
                    ;
                    setIsLoading(true);
                    axios_default().post("/api/register", {
                        user_data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                            custom_metadata: {
                                expectations: data === null || data === void 0 ? void 0 : (ref1 = data.metadata) === null || ref1 === void 0 ? void 0 : ref1.expectations
                            }
                        }),
                        captcha_token: captchaToken
                    }).then(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(res) {
                            var ref;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            window === null || window === void 0 ? void 0 : (ref = window.Reflio) === null || ref === void 0 ? void 0 : ref.signup(data.email)
                                        ];
                                    case 1:
                                        _state.sent();
                                        // tenants api calling
                                        axios_default().get("/api/user_tenants_details", {
                                            params: {
                                                auth_key: res.data.user.key.auth_key
                                            }
                                        }).then(function() {
                                            var _ref = (0,_async_to_generator/* default */.Z)(function(res2) {
                                                var ref, ref1, ref2, default_tenant, _obj, ref3, freshwork;
                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            setIsLoading(false);
                                                            (0,lib.deleteCookie)(url.auth_cookie_name);
                                                            (0,lib.deleteCookie)(url.refresh_cookie_name);
                                                            (0,lib.deleteCookie)(url.uuid_cookie_name);
                                                            (0,lib.deleteCookie)(url.global_auth_cookie_name);
                                                            default_tenant = (ref = res2.data.data.tenants) === null || ref === void 0 ? void 0 : ref.find(function(tenant) {
                                                                return tenant === null || tenant === void 0 ? void 0 : tenant.default;
                                                            });
                                                            //
                                                            // cookie setting
                                                            if (!res.data.user.email_verified) {
                                                                (0,lib.setCookie)(url.global_auth_cookie_name, (0,functions.encryptDataWithAES)(JSON.stringify(res.data.user)), {
                                                                    maxAge: 86400,
                                                                    domain: url.cookies_domain_name,
                                                                    path: "/"
                                                                });
                                                            } else {
                                                                (0,lib.setCookie)(url.auth_cookie_name, (0,functions.encryptDataWithAES)(res.data.user.key.auth_key), {
                                                                    maxAge: 86400,
                                                                    domain: url.cookies_domain_name,
                                                                    path: "/"
                                                                });
                                                                (0,lib.setCookie)(url.uuid_cookie_name, (0,functions.encryptDataWithAES)((0,uuidv4/* uuid */.Vj)()), {
                                                                    maxAge: 860400,
                                                                    domain: url.cookies_domain_name,
                                                                    path: "/"
                                                                });
                                                                (0,lib.setCookie)(url.refresh_cookie_name, (0,functions.encryptDataWithAES)(res.data.user.key.refresh_key), {
                                                                    maxAge: 860400,
                                                                    domain: url.cookies_domain_name,
                                                                    path: "/"
                                                                });
                                                                (0,lib.setCookie)("auth_expiry_time", Date.now() + 86400000, {
                                                                    domain: url.cookies_domain_name,
                                                                    path: "/",
                                                                    maxAge: 86400
                                                                });
                                                            }
                                                            recaptchaRef === null || recaptchaRef === void 0 ? void 0 : (ref1 = recaptchaRef.current) === null || ref1 === void 0 ? void 0 : ref1.reset();
                                                            setCaptchaToken(null);
                                                            //mixpanel tracking
                                                            mixpanel_module/* default.identify */.Z.identify(res.data.user.email);
                                                            (0,mixpnael/* MixpanelTracking */.n5)(mixpnael/* MixpanelEventName.sign_up */.aK.sign_up, (_obj = {}, (0,_define_property/* default */.Z)(_obj, mixpnael/* MixpanelPropertiesName.user_name */.Oe.user_name, data === null || data === void 0 ? void 0 : data.name), (0,_define_property/* default */.Z)(_obj, mixpnael/* MixpanelPropertiesName.user_email */.Oe.user_email, data === null || data === void 0 ? void 0 : data.email), (0,_define_property/* default */.Z)(_obj, mixpnael/* MixpanelPropertiesName.tenant_name */.Oe.tenant_name, data === null || data === void 0 ? void 0 : data.app_name), _obj));
                                                            if (!(data === null || data === void 0 ? void 0 : (ref2 = data.metadata) === null || ref2 === void 0 ? void 0 : ref2.expectations)) return [
                                                                3,
                                                                2
                                                            ];
                                                            return [
                                                                4,
                                                                axios_default().post("/api/freshwork_contact", {
                                                                    data: {
                                                                        email: data === null || data === void 0 ? void 0 : data.email,
                                                                        contact_info: {
                                                                            custom_field: {
                                                                                cf_idea: data === null || data === void 0 ? void 0 : (ref3 = data.metadata) === null || ref3 === void 0 ? void 0 : ref3.expectations
                                                                            }
                                                                        }
                                                                    }
                                                                })
                                                            ];
                                                        case 1:
                                                            freshwork = _state.sent();
                                                            _state.label = 2;
                                                        case 2:
                                                            if (is_log_in_by_discourse) {
                                                                (0,discourse_auth/* discourse_redirect */.kM)({
                                                                    sso: sso,
                                                                    sig: sig,
                                                                    router: router,
                                                                    user: res.data.user
                                                                });
                                                            } else if (is_log_in_by_tradly_integration) {
                                                                (0,tradly_integration_auth/* tradly_integration_redirect */.we)({
                                                                    sso: sso,
                                                                    sig: sig,
                                                                    router: router,
                                                                    user: res.data.user
                                                                });
                                                            } else {
                                                                if (!res.data.user.email_verified) {
                                                                    if (default_tenant === null || default_tenant === void 0 ? void 0 : default_tenant.super_user) {
                                                                        router.push("/verify_email?to=/onboarding");
                                                                    } else {
                                                                        router.push("/verify_email");
                                                                    }
                                                                } else {
                                                                    if (default_tenant === null || default_tenant === void 0 ? void 0 : default_tenant.super_user) {
                                                                        router.push("/onboarding");
                                                                    } else {
                                                                        router.push(url.default_site_url);
                                                                    }
                                                                }
                                                            }
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            });
                                            return function(res2) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }());
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(res) {
                            return _ref.apply(this, arguments);
                        };
                    }()).catch(function(err) {
                        var ref, ref1;
                        var message = err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message;
                        setIsLoading(false);
                        if (message) {
                            setOpenAlert(true);
                            setAlert_type("error");
                            setMessage(message);
                            recaptchaRef.current.reset();
                            setCaptchaToken(null);
                        } else {
                            setOpenAlert(true);
                            setAlert_type("error");
                            setMessage("Something is wrong , please try latter");
                            recaptchaRef.current.reset();
                            setCaptchaToken(null);
                        }
                    });
                }
                return [
                    2
                ];
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    function onChange(value) {
        return _onChange.apply(this, arguments);
    }
    function _onChange() {
        _onChange = (0,_async_to_generator/* default */.Z)(function(value) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setCaptchaToken(value);
                return [
                    2
                ];
            });
        });
        return _onChange.apply(this, arguments);
    }
    // errors
    (0,react.useEffect)(function() {
        var ref;
        if (errors === null || errors === void 0 ? void 0 : (ref = errors.metadata) === null || ref === void 0 ? void 0 : ref.app_name) {
            setOpenAlert(true);
            setAlert_type("error");
            setMessage("App name should be only Alphabets. No special symbols or numbers allowed. App name character should not be more than 30.");
        }
    }, [
        errors === null || errors === void 0 ? void 0 : (ref = errors.metadata) === null || ref === void 0 ? void 0 : ref.app_name
    ]);
    var _query;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                className: " w-full md:w-[400px] lg:w-[450px]   fixed bottom-0 md:bottom-5   right-0 z-[99999999999999999999999999999999999999999] ",
                type: alert_type,
                open: open_alert,
                setOpen: setOpenAlert,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: message
                })
            }),
            isLoggedIn && sso && sig && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLoading/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative grid grid-cols-1 md:grid-cols-2 min-h-screen bg-[#F0F7F5] p-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " w-full px-5 pt-10 flex items-start justify-center order-1 md:order-none ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " flex flex-col gap-4 max-w-md",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "h1 !font-medium",
                                    children: "Example prompts"
                                }),
                                build_examples === null || build_examples === void 0 ? void 0 : build_examples.map(function(item, index) {
                                    if (index < 4) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: " space-y-1 border border-gray-300 p-4 rounded-md ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: " text-base font-bold",
                                                    children: item === null || item === void 0 ? void 0 : item.type
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: " text-base",
                                                    children: item === null || item === void 0 ? void 0 : item.description
                                                })
                                            ]
                                        }, item === null || item === void 0 ? void 0 : item.type);
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " pt-10 pb-16 bg-white shadow-onboarding_card p-8 rounded-3xl w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "max-w-3xl mx-auto text-center pb-12 md:pb-20",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "h1",
                                        children: "Sign Up to Get Started"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-gray-600 text-center mt-6 text-lg",
                                        children: [
                                            "Create a free account or",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: {
                                                    pathname: "/signin",
                                                    query: (_query = router.query) !== null && _query !== void 0 ? _query : {
                                                        to: "https://superadmin.tradly.app"
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "text-blue-600 hover:underline transition duration-150 ease-in-out",
                                                    children: "Sign in"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "max-w-sm mx-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    onSubmit: handleSubmit(onSubmit),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-wrap -mx-3 mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-full px-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "block text-gray-800 text-sm font-medium mb-1",
                                                        htmlFor: "name",
                                                        children: [
                                                            "Your Name",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-red-600",
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        id: "name",
                                                        type: "text",
                                                        className: "form-input w-full text-gray-800",
                                                        placeholder: "Enter your name"
                                                    }, register("name")), {
                                                        required: true
                                                    }))
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-wrap -mx-3 mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-full px-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "block text-gray-800 text-sm font-medium mb-1",
                                                        htmlFor: "name",
                                                        children: [
                                                            "App Name",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-red-600",
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-center justify-start gap-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                id: "name",
                                                                type: "text",
                                                                className: " flex-grow form-input w-full text-gray-800",
                                                                placeholder: "Only Alphabets."
                                                            }, register("metadata.app_name", {
                                                                pattern: /^[a-zA-Z]{1,30}$/
                                                            })), {
                                                                required: true
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: " flex-none text-base font-medium",
                                                                children: ".tradly.co"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-wrap -mx-3 mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-full px-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: "block text-gray-800 text-sm font-medium mb-1",
                                                        htmlFor: "email",
                                                        children: [
                                                            "Email ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-red-600",
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        id: "email",
                                                        type: "email",
                                                        className: "form-input w-full text-gray-800",
                                                        placeholder: "Enter your email address"
                                                    }, register("email")), {
                                                        required: true
                                                    }))
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-wrap -mx-3 mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-full px-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "block text-gray-800 text-sm font-medium mb-1",
                                                        htmlFor: "password",
                                                        children: [
                                                            "Password ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-red-600",
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        id: "password",
                                                        type: "password",
                                                        className: "form-input w-full text-gray-800",
                                                        placeholder: "Enter your password"
                                                    }, register("password")), {
                                                        required: true
                                                    }))
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-wrap -mx-3 mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-full px-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                        className: " text-gray-800 text-sm font-medium mb-1 flex items-center justify-between",
                                                        htmlFor: "expectations",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    "What do you want to build & launch? ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "text-red-600",
                                                                        children: "*"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: " flex items-center gap-1",
                                                                children: [
                                                                    AllIcons.ai_icon,
                                                                    "Ai Powered"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        id: "expectations",
                                                        type: "text",
                                                        className: "form-input w-full text-gray-800",
                                                        placeholder: "",
                                                        rows: 3
                                                    }, register("metadata.expectations")), {
                                                        required: true
                                                    }))
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full flex items-center justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm, {
                                                ref: recaptchaRef,
                                                onChange: onChange,
                                                sitekey: "6LfcsrodAAAAAEWeyP38Jbjd1hbwqjgmgx7RGzBs"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-wrap -mx-3 mt-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-full px-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    type: "submit",
                                                    disabled: isLoading,
                                                    className: "btn_primary w-full flex items-center justify-center gap-4 ".concat(isLoading && "cursor-not-allowed"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Sign up"
                                                        }),
                                                        isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_loading/* default */.Z, {
                                                            text_color: "text-white"
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-sm text-gray-500 text-center mt-3",
                                            children: [
                                                "By creating an account, you agree to the",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "underline",
                                                    href: "/terms-conditions",
                                                    target: "_blank",
                                                    children: "terms & conditions"
                                                }),
                                                ", and our",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "underline",
                                                    href: "/privacy-policy",
                                                    target: "_blank",
                                                    children: "privacy policy"
                                                }),
                                                "."
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Signup = (Sign_up);


/***/ }),

/***/ 65233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kM": function() { return /* binding */ discourse_redirect; },
/* harmony export */   "wL": function() { return /* binding */ check_discourse_payload; }
/* harmony export */ });
/* unused harmony export validateSignature */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Shared_ErrorComponent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46316);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42474);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(crypto__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12918);
/* provided dependency */ var process = __webpack_require__(83454);




// validateSignature
var validateSignature = function(payload, providedSig, secret) {
    try {
        var hmac = crypto__WEBPACK_IMPORTED_MODULE_2___default().createHmac("sha256", secret);
        hmac.update(payload);
        var calculatedSig = crypto__WEBPACK_IMPORTED_MODULE_2___default().createHmac("sha256", secret).update(payload).digest("hex");
        return calculatedSig === providedSig;
    } catch (error) {
        console.error("Error validating signature:", error);
        return false;
    }
};
var check_discourse_payload = function(param) {
    var component = param.component, sso = param.sso, sig = param.sig;
    var decodedPayload = decodeBase64(sso);
    var ref = decodedPayload ? JSON.parse('{"' + decodeURI(decodedPayload === null || decodedPayload === void 0 ? void 0 : decodedPayload.replace(/&/g, '","').replace(/=/g, '":"')) + '"}') : {}, nonce = ref.nonce, return_sso_url = ref.return_sso_url;
    var discourseConnectSecret = process.env.DISCOURSE_SSO_SECRET;
    var isValidSignature = validateSignature(sso, sig, discourseConnectSecret);
    if (isValidSignature) {
        return component;
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shared_ErrorComponent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {});
    }
};
var decodeBase64 = function(encodedString) {
    try {
        var decodedString = atob(encodedString);
        return decodedString;
    } catch (error) {
        console.error("Error decoding Base64:", error);
        return null;
    }
};
var discourse_redirect = function(param) {
    var sso = param.sso, sig = param.sig, router = param.router, user = param.user;
    var decodedPayload = decodeBase64(sso);
    var ref = JSON.parse('{"' + decodeURI(decodedPayload.replace(/&/g, '","').replace(/=/g, '":"')) + '"}'), nonce = ref.nonce, return_sso_url = ref.return_sso_url;
    var payloadObj = {
        nonce: nonce,
        email: user.email,
        external_id: user.id,
        username: user.email,
        name: user.name
    };
    var encodedPayload = btoa(new URLSearchParams(payloadObj).toString());
    var discourseConnectSecret = process.env.DISCOURSE_SSO_SECRET;
    var hmac = crypto__WEBPACK_IMPORTED_MODULE_2___default().createHmac("sha256", discourseConnectSecret);
    hmac.update(encodedPayload);
    var signature = hmac.digest("hex");
    var queryParams = new URLSearchParams({
        sso: encodedPayload,
        sig: signature
    });
    window.location.href = "".concat(decodeURIComponent(return_sso_url), "?").concat(queryParams.toString());
};


/***/ }),

/***/ 20435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K4": function() { return /* binding */ check_tradly_auth_integration_payload; },
/* harmony export */   "we": function() { return /* binding */ tradly_integration_redirect; }
/* harmony export */ });
/* unused harmony export isTradlyIntegrationHaveValidateSignature */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Shared_ErrorComponent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46316);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42474);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(crypto__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12918);




// validateSignature
var isTradlyIntegrationHaveValidateSignature = function(payload, providedSig, secret) {
    try {
        var calculatedSig = crypto__WEBPACK_IMPORTED_MODULE_2___default().createHmac("sha256", secret).update(payload).digest("hex");
        return calculatedSig === providedSig;
    } catch (error) {
        console.error("Error validating signature:", error);
        return false;
    }
};
var check_tradly_auth_integration_payload = function(param) {
    var component = param.component, sso = param.sso, sig = param.sig;
    var decodedPayload = decodeBase64(sso);
    var ref = decodedPayload ? JSON.parse(decodedPayload) : {}, nonce = ref.nonce, return_url = ref.return_url;
    var TradlyIntegrationConnectSecret = "419ADD89629DGYA2E647527E6E7EF8344";
    var isValidSignature = isTradlyIntegrationHaveValidateSignature(decodedPayload, sig, TradlyIntegrationConnectSecret);
    if (isValidSignature) {
        return component;
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shared_ErrorComponent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {});
    }
};
var decodeBase64 = function(encodedString) {
    try {
        var decodedString = atob(encodedString);
        return decodedString;
    } catch (error) {
        console.error("Error decoding Base64:", error);
        return null;
    }
};
var tradly_integration_redirect = function(param) {
    var sso = param.sso, sig = param.sig, router = param.router, user = param.user;
    var decodedPayload = decodeBase64(sso);
    var ref = JSON.parse(decodedPayload), nonce = ref.nonce, return_url = ref.return_url;
    var payloadObj = {
        nonce: nonce,
        external_id: user.id,
        email: user.email,
        username: user.email,
        first_name: user.name,
        last_name: "",
        email_verified: user.email_verified
    };
    var encodedPayload = btoa(JSON.stringify(payloadObj));
    var discourseConnectSecret = "419ADD89629DGYA2E647527E6E7EF8344";
    var hmac = crypto__WEBPACK_IMPORTED_MODULE_2___default().createHmac("sha256", discourseConnectSecret);
    hmac.update(JSON.stringify(payloadObj));
    var signature = hmac.digest("hex");
    var queryParams = new URLSearchParams({
        payload: encodedPayload,
        sig: signature
    });
    window.location.href = "".concat(decodeURIComponent(return_url), "?").concat(queryParams.toString());
};


/***/ })

}]);